module.exports = __webpack_public_path__ + "static/media/ecorce.45a39a2e.jpeg";